/**
 * Binds a mouseup event that highlights all contents of an element.
 */
angular.module('hjApp').directive('highlightContent', [
    function () {
        return {
            restrict: 'A',
            link: function (scope, element) {
                element.on('mouseup', function () {
                    var containerId = element[0].id,
                        range;

                    if (document.selection) {
                        range = document.body.createTextRange();
                        range.moveToElementText(document.getElementById(containerId));
                        range.select();
                    } else if (window.getSelection()) {
                        range = document.createRange();
                        range.selectNode(document.getElementById(containerId));
                        window.getSelection().removeAllRanges();
                        window.getSelection().addRange(range);
                    }
                });
            }
        };
    }
]);
